/**
 * App-wide date formatting. Every timestamp the UI shows uses these so the
 * format is consistent (DD/MM/YYYY HH:mm, 24-hour, local time) regardless of the
 * viewer's browser locale.
 */

const pad = (n: number): string => String(n).padStart(2, '0');

/** DD/MM/YYYY HH:mm — e.g. 15/12/2026 14:12. Empty string for invalid input. */
export function formatDateTime(input: string | number | Date | null | undefined): string {
  if (input == null) return '';
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** DD/MM/YYYY — e.g. 15/12/2026. Empty string for invalid input. */
export function formatDate(input: string | number | Date | null | undefined): string {
  if (input == null) return '';
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** DD/MM — compact form for dense chart axes. */
export function formatDateShort(input: string | number | Date | null | undefined): string {
  if (input == null) return '';
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
}
